// WebAuthn / passkey helpers for CONVITEL ERP
import { api, authStore } from "@/lib/api";

const ORIGIN = window.location.origin;

// base64url ↔ bytes
export function b64ToBytes(s) {
  const pad = (4 - (s.length % 4)) % 4;
  const bin = atob(s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat(pad));
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return arr;
}

export function bytesToB64(buf) {
  const b = new Uint8Array(buf);
  let s = "";
  for (const x of b) s += String.fromCharCode(x);
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function optionBytes(o) {
  const clone = { ...o };
  clone.challenge = b64ToBytes(o.challenge).buffer;
  if (o.user?.id) clone.user = { ...o.user, id: b64ToBytes(o.user.id).buffer };
  clone.excludeCredentials = (o.excludeCredentials || []).map((x) => ({
    ...x,
    id: b64ToBytes(x.id).buffer,
  }));
  clone.allowCredentials = (o.allowCredentials || []).map((x) => ({
    ...x,
    id: b64ToBytes(x.id).buffer,
  }));
  return clone;
}

function credentialJSON(c, registration) {
  const r = c.response;
  const out = {
    id: c.id,
    rawId: bytesToB64(c.rawId),
    type: c.type,
    response: {
      clientDataJSON: bytesToB64(r.clientDataJSON),
      ...(registration
        ? {
            attestationObject: bytesToB64(r.attestationObject),
            transports: r.getTransports ? r.getTransports() : [],
          }
        : {
            authenticatorData: bytesToB64(r.authenticatorData),
            signature: bytesToB64(r.signature),
            userHandle: r.userHandle ? bytesToB64(r.userHandle) : null,
          }),
    },
    clientExtensionResults: c.getClientExtensionResults(),
  };
  if (c.authenticatorAttachment) out.authenticatorAttachment = c.authenticatorAttachment;
  return out;
}

export function passkeysSupported() {
  return !!(window.PublicKeyCredential && navigator.credentials);
}

// Register a passkey for the currently logged-in user
export async function registerPasskey(label = "Este dispositivo") {
  const { data } = await api.http.post("/auth/webauthn/register/options", { origin: ORIGIN });
  const cred = await navigator.credentials.create({ publicKey: optionBytes(data) });
  if (!cred) throw new Error("Registro cancelado");
  await api.http.post("/auth/webauthn/register/verify", {
    credential: credentialJSON(cred, true),
    label,
    origin: ORIGIN,
  });
  return true;
}

// Login with a passkey. Returns {access_token, user}
export async function loginWithPasskey() {
  const { data } = await api.http.post("/auth/webauthn/login/options", { origin: ORIGIN });
  const cred = await navigator.credentials.get({ publicKey: optionBytes(data) });
  if (!cred) throw new Error("Login cancelado");
  const { data: res } = await api.http.post("/auth/webauthn/login/verify", {
    credential: credentialJSON(cred, false),
    origin: ORIGIN,
  });
  authStore.set(res.access_token);
  return res;
}

export async function listPasskeys() {
  const { data } = await api.http.get("/auth/webauthn/credentials");
  return data;
}

export async function deletePasskey(id) {
  await api.http.delete(`/auth/webauthn/credentials/${id}`);
}
